import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import slugify from '../utils/slugify.js';
import { getStateSlug, getCitySlug } from '../config/cityConfig';

const SearchFilters = ({ onFilterChange, initialFilters = {}, isHomePage = false, specialties: propSpecialties }) => {
  const navigate = useNavigate();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [specialties, setSpecialties] = useState(propSpecialties || []);
  const [loading, setLoading] = useState(true);
  const [localFilters, setLocalFilters] = useState({
    state: initialFilters.state || '',
    city: initialFilters.city || '',
    specialty: initialFilters.specialty || 'ginecologos',
    minRating: initialFilters.minRating || ''
  });

  // Cargar datos iniciales
  useEffect(() => {
    const loadData = async () => {
      try {
        console.log('Cargando datos iniciales...');
        
        // Cargar estados
        const statesRes = await api.get('/states');
        console.log('Estados cargados:', statesRes.data);
        setStates(statesRes.data);

        if (initialFilters.state) {
          const citiesRes = await api.get(`/cities/${initialFilters.state}`);
          console.log('Ciudades iniciales:', citiesRes.data);
          setCities(citiesRes.data);
        }

        // Cargar especialidades
        console.log('Intentando cargar especialidades...');
        console.log('propSpecialties:', propSpecialties);
        
        if (!propSpecialties) {
          try {
            console.log('Cargando especialidades desde el API...');
            const specialtiesRes = await api.get('/specialties');
            console.log('Respuesta del API de especialidades:', specialtiesRes);
            console.log('Especialidades cargadas:', specialtiesRes.data);
            if (Array.isArray(specialtiesRes.data) && specialtiesRes.data.length > 0) {
              setSpecialties(specialtiesRes.data);
            } else {
              throw new Error('No se recibieron especialidades válidas del API');
            }
          } catch (error) {
            console.error('Error cargando especialidades:', error);
            console.log('Usando lista de especialidades por defecto');
            const defaultSpecialties = [
              { slug: 'ginecologos', nombre: 'Ginecología' },
              { slug: 'urologos', nombre: 'Urología' },
              { slug: 'pediatras', nombre: 'Pediatría' },
              { slug: 'dermatologos', nombre: 'Dermatología' },
              { slug: 'traumatologos', nombre: 'Traumatología' },
              { slug: 'dentistas', nombre: 'Dentistas' },
              { slug: 'nutriologos', nombre: 'Nutriología' },
              { slug: 'oftalmologos', nombre: 'Oftalmología' },
              { slug: 'psiquiatras', nombre: 'Psiquiatría' },
              { slug: 'cardiologos', nombre: 'Cardiología' },
              { slug: 'endocrinologos', nombre: 'Endocrinología' },
              { slug: 'gastroenterologos', nombre: 'Gastroenterología' },
              { slug: 'cirujanos-plasticos', nombre: 'Cirugía Plástica' },
              { slug: 'psicologos', nombre: 'Psicología' },
              { slug: 'otorrinolaringologos', nombre: 'Otorrinolaringología' },
              { slug: 'podologos', nombre: 'Podología' },
              { slug: 'acupuntores', nombre: 'Acupuntura' },
              { slug: 'reumatologos', nombre: 'Reumatología' },
              { slug: 'internistas', nombre: 'Medicina Interna' },
              { slug: 'geriatras', nombre: 'Geriatría' },
              { slug: 'angiologos', nombre: 'Angiología' },
              { slug: 'neurologos', nombre: 'Neurología' },
              { slug: 'homeopatas', nombre: 'Homeopatía' },
              { slug: 'alergologos', nombre: 'Alergología' },
              { slug: 'fisioterapeutas', nombre: 'Fisioterapía' },
              { slug: 'laboratorios-de-analisis-clinicos', nombre: 'Laboratorio de Análisis Clínicos' },
              { slug: 'nefrologos', nombre: 'Nefrología' },
              { slug: 'proctologos', nombre: 'Proctología' },
              { slug: 'neumologos', nombre: 'Neumología' },
              { slug: 'medicos-familiares', nombre: 'Medicina Familiar' },
              { slug: 'spa-terapeuticos', nombre: 'Spa Terapéutico' },
              { slug: 'farmacias', nombre: 'Farmacias' },
              { slug: 'audiologos', nombre: 'Audiología' },
              { slug: 'masajistas', nombre: 'Masajistas' },
              { slug: 'tiendas-de-articulos-ortopedicos', nombre: 'Tiendas de Articulos Ortopédicos' },
              { slug: 'tiendas-de-sillas-de-ruedas', nombre: 'Tiendas de Sillas de Ruedas' },
              { slug: 'opticas', nombre: 'Opticas' },
              { slug: 'radiologos', nombre: 'Radiologos' },
              { slug: 'optometristas', nombre: 'Optometristas' },
              { slug: 'quiropractico', nombre: 'Quiropractico' },
              { slug: 'periodoncistas', nombre: 'Periodoncistas' },
              { slug: 'esteticistas', nombre: 'Esteticistas' }
            ];
            setSpecialties(defaultSpecialties);
            console.log('Lista de especialidades por defecto establecida:', defaultSpecialties);
          }
        } else {
          console.log('Usando especialidades proporcionadas como prop:', propSpecialties);
        }
      } catch (error) {
        console.error('Error cargando datos:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [initialFilters.state, propSpecialties]);

  // Manejar cambio de estado
  const handleStateChange = async (e) => {
    const stateName = e.target.value;
    console.log('Estado seleccionado:', stateName);

    setLocalFilters(prev => ({ ...prev, state: stateName, city: '' }));
    setCities([]);

    if (stateName) {
      try {
        const response = await api.get(`/cities/${stateName}`);
        const citiesWithSlugs = response.data.map(city => ({
          ...city,
          displayName: city.nombre === 'Acapulco de Juarez' ? 'Acapulco' : city.nombre,
          slug: city.nombre === 'Acapulco de Juarez' ? 'acapulco' : slugify(city.nombre)
        }));
        console.log('Ciudades cargadas:', citiesWithSlugs);
        setCities(citiesWithSlugs);
      } catch (error) {
        console.error('Error cargando ciudades:', error);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Cambio en ${name}:`, value);
    if (name === 'state') {
      handleStateChange(e);
    } else {
      setLocalFilters(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleApplyFilters = () => {
    console.log('Filtros a aplicar:', localFilters);
    
    // Si hay una ciudad seleccionada, construir la URL usando slugs
    if (localFilters.state && localFilters.city) {
      const stateSlug = getStateSlug(localFilters.state);
      const citySlug = getCitySlug(localFilters.city);
      const specialtySlug = localFilters.specialty || 'ginecologos';

      if (stateSlug && citySlug) {
        const searchParams = new URLSearchParams();
        if (localFilters.minRating) {
          searchParams.append('minRating', localFilters.minRating);
        }
        
        const queryString = searchParams.toString();
        const url = `/${stateSlug}/${specialtySlug}-en-${citySlug}${queryString ? `?${queryString}` : ''}`;
        
        console.log('Redirigiendo a:', url);
        navigate(url);
        return;
      }
    }

    // Si no hay ciudad seleccionada o no se encontró el slug, aplicar filtros normalmente
    onFilterChange({
      state: localFilters.state,
      city: localFilters.city,
      specialty: localFilters.specialty || 'ginecologos',
      minRating: localFilters.minRating
    });
  };

  if (loading) {
    return <div className="animate-pulse">Cargando filtros...</div>;
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border">
      <h3 className="text-lg font-semibold mb-4">Filtros de búsqueda</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
          <select
            name="state"
            value={localFilters.state}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-gray-900 bg-white"
          >
            <option value="">Todos los estados</option>
            {states.map(state => (
              <option key={state.slug} value={state.nombre}>
                {state.nombre}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Ciudad</label>
          <select
            name="city"
            value={localFilters.city}
            onChange={handleChange}
            disabled={!localFilters.state}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-gray-900 bg-white"
          >
            <option value="">Todas las ciudades</option>
            {cities.map(city => (
              <option key={city.clave} value={city.nombre}>
                {city.displayName || city.nombre}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Especialidad</label>
          <select
            name="specialty"
            value={localFilters.specialty}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-gray-900 bg-white"
          >
            <option value="ginecologos" className="text-gray-900">Ginecología</option>
            <option value="urologos" className="text-gray-900">Urología</option>
            <option value="pediatras" className="text-gray-900">Pediatría</option>
            <option value="dermatologos" className="text-gray-900">Dermatología</option>
            <option value="traumatologos" className="text-gray-900">Traumatología</option>
            <option value="dentistas" className="text-gray-900">Dentistas</option>
            <option value="nutriologos" className="text-gray-900">Nutriología</option>
            <option value="oftalmologos" className="text-gray-900">Oftalmología</option>
            <option value="psiquiatras" className="text-gray-900">Psiquiatría</option>
            <option value="cardiologos" className="text-gray-900">Cardiología</option>
            <option value="endocrinologos" className="text-gray-900">Endocrinología</option>
            <option value="gastroenterologos" className="text-gray-900">Gastroenterología</option>
            <option value="cirujanos-plasticos" className="text-gray-900">Cirugía Plástica</option>
            <option value="psicologos" className="text-gray-900">Psicología</option>
            <option value="otorrinolaringologos" className="text-gray-900">Otorrinolaringología</option>
            <option value="podologos" className="text-gray-900">Podología</option>
            <option value="acupuntores" className="text-gray-900">Acupuntura</option>
            <option value="reumatologos" className="text-gray-900">Reumatología</option>
            <option value="internistas" className="text-gray-900">Medicina Interna</option>
            <option value="geriatras" className="text-gray-900">Geriatría</option>
            <option value="angiologos" className="text-gray-900">Angiología</option>
            <option value="neurologos" className="text-gray-900">Neurología</option>
            <option value="homeopatas" className="text-gray-900">Homeopatía</option>
            <option value="alergologos" className="text-gray-900">Alergología</option>
            <option value="fisioterapeutas" className="text-gray-900">Fisioterapía</option>
            <option value="laboratorios-de-analisis-clinicos" className="text-gray-900">Laboratorio de Análisis Clínicos</option>
            <option value="nefrologos" className="text-gray-900">Nefrología</option>
            <option value="proctologos" className="text-gray-900">Proctología</option>
            <option value="neumologos" className="text-gray-900">Neumología</option>
            <option value="medicos-familiares" className="text-gray-900">Medicina Familiar</option>
            <option value="spa-terapeuticos" className="text-gray-900">Spa Terapéutico</option>
            <option value="farmacias" className="text-gray-900">Farmacias</option>
            <option value="audiologos" className="text-gray-900">Audiología</option>
            <option value="masajistas" className="text-gray-900">Masajistas</option>
            <option value="tiendas-de-articulos-ortopedicos" className="text-gray-900">Tiendas de Articulos Ortopédicos</option>
            <option value="tiendas-de-sillas-de-ruedas" className="text-gray-900">Tiendas de Sillas de Ruedas</option>
            <option value="opticas" className="text-gray-900">Opticas</option>
            <option value="radiologos" className="text-gray-900">Radiologos</option>
            <option value="optometristas" className="text-gray-900">Optometristas</option>
            <option value="quiropractico" className="text-gray-900">Quiropractico</option>
            <option value="periodoncistas" className="text-gray-900">Periodoncistas</option>
            <option value="esteticistas" className="text-gray-900">Esteticistas</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Calificación mínima</label>
          <select
            name="minRating"
            value={localFilters.minRating}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-gray-900 bg-white"
          >
            <option value="">Cualquier calificación</option>
            <option value="4">4+ estrellas</option>
            <option value="3">3+ estrellas</option>
            <option value="2">2+ estrellas</option>
          </select>
        </div>
      </div>

      <div className="mt-4 flex justify-end">
        <button
          onClick={handleApplyFilters}
          className="bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700 transition-colors"
        >
          Aplicar filtros
        </button>
      </div>
    </div>
  );
};

export default SearchFilters; 